import { useEffect, useState } from 'react';
import { useQuery } from 'urql';
import { queryWidgetConfigurationQuery } from '../../graphql/services';
import { WidgetConfiguration } from './booking-types';

/**
 * Custom hook to handle widget configuration loading
 */
export const useWidgetConfiguration = (initialConfig?: any) => {
  const [widgetConfiguration, setWidgetConfiguration] = useState<WidgetConfiguration | null>(
    initialConfig || null
  );
  const [bookingPageConfiguration, setBookingPageConfiguration] = useState(null);

  const [isLoading, setIsLoading] = useState(!initialConfig);
  const [configFetched, setConfigFetched] = useState(!!initialConfig);

  const [result] = useQuery({
    query: queryWidgetConfigurationQuery,
    requestPolicy: 'network-only',
    pause: !!initialConfig,  // Don't fetch if we already have a config
  });

  useEffect(() => {
    // Only run this effect if we haven't already fetched config
    if (!configFetched && !result.fetching && result.data) {
      setIsLoading(false);
      setWidgetConfiguration(result.data.widgetConfiguration.domainConfiguration);
      setBookingPageConfiguration(result.data.widgetConfiguration.bookingPageConfig);
      // Mark as fetched to prevent further updates
      setConfigFetched(true);
    }
  }, [result.fetching, result.data, configFetched]);

  return {
    widgetConfiguration,
    isLoading,
    bookingPageConfiguration,
    setWidgetConfiguration
  };
};

export default useWidgetConfiguration;
